import { create } from 'zustand';

interface ITradeDataSortItem {
  sortBy: string;
  sort: 'asc' | 'desc';
}

interface ITradeDataSort {
  billsOfLadingListSortParams?: ITradeDataSortItem;
  marketAnalyticsTableSortParams?: ITradeDataSortItem;
  marketAnalyticsPopupTableSortParams?: ITradeDataSortItem;
  supplierBuyerCountrySortParams?: ITradeDataSortItem;
  supplierBuyerCountryPopupTableSortParams?: ITradeDataSortItem;
  supplierSortParams?: ITradeDataSortItem;
  buyerSortParams?: ITradeDataSortItem;
  supplierPopupTableSortParams?: ITradeDataSortItem;
  buyerPopupTableSortParams?: ITradeDataSortItem;
  pooSortParams?: ITradeDataSortItem;
  podSortParams?: ITradeDataSortItem;
  podPopupTableSortParams?: ITradeDataSortItem;
  pooPopupTableSortParams?: ITradeDataSortItem;
  ctdBillsOfLadingListSortParams?: ITradeDataSortItem;
  ctdCompanyAggregatedByBOLSortParams?: ITradeDataSortItem;
  unitPriceSupplierSortParams?: ITradeDataSortItem;
  unitPriceBuyerSortParams?: ITradeDataSortItem;
  averageUnitPriceSortParams?: ITradeDataSortItem;
  ctdBuyersSuppliersList?: ITradeDataSortItem;
}

export interface IAction {
  setSort: (key: keyof ITradeDataSort, value: ITradeDataSortItem) => void;
}

export const useTradeDataSortStore = create<ITradeDataSort & IAction>((set) => ({
  billsOfLadingListSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  marketAnalyticsTableSortParams: {
    sort: 'asc',
    sortBy: 'month',
  },
  marketAnalyticsPopupTableSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  supplierBuyerCountrySortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  supplierBuyerCountryPopupTableSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  supplierSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  supplierPopupTableSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  buyerSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  buyerPopupTableSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  pooPopupTableSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  podPopupTableSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  podSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  pooSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  ctdBillsOfLadingListSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  ctdCompanyAggregatedByBOLSortParams: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  ctdBuyersSuppliersList: {
    sort: 'desc',
    sortBy: 'value_usd',
  },
  unitPriceSupplierSortParams: {
    sort: 'desc',
    sortBy: 'transactions',
  },
  unitPriceBuyerSortParams: {
    sort: 'desc',
    sortBy: 'transactions',
  },
  averageUnitPriceSortParams: {
    sort: 'desc',
    sortBy: 'transactions',
  },
  setSort: (key: keyof ITradeDataSort, value: ITradeDataSortItem) => {
    set((prevState: ITradeDataSort & IAction) => ({ ...prevState, ...{ [key]: value } }));
  },
}));
